module.exports = __webpack_public_path__ + "img/notesscrolling-es.42a1d8f4.png";